module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('loading'), _vm._v(" "), _c('rotate-detect'), _vm._v(" "), _c('div', {
    staticClass: "topbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('nav-bar', {
    attrs: {
      "nav": _vm.showNav
    }
  }), _vm._v(" "), _c('index-sec1'), _vm._v(" "), _c('index-sec2', {
    on: {
      "childOpen": _vm.videoFarther
    }
  }), _vm._v(" "), _c('index-sec3'), _vm._v(" "), _c('index-sec4'), _vm._v(" "), _c('index-sec5'), _vm._v(" "), _c('index-sec6'), _vm._v(" "), _c('index-sec7', {
    on: {
      "childOpen": _vm.princeFarther
    }
  }), _vm._v(" "), _c('index-sec8'), _vm._v(" "), _c('index-sec9', {
    on: {
      "childOpen": _vm.bookFarther
    }
  }), _vm._v(" "), _c('index-sec10'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('booking', {
    attrs: {
      "open": _vm.openBooking
    },
    on: {
      "close": _vm.bookFarther
    }
  }), _vm._v(" "), _c('prince', {
    attrs: {
      "open": _vm.openPrince
    },
    on: {
      "close": _vm.princeFarther
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "open": _vm.openVideo
    },
    on: {
      "close": _vm.videoFarther
    }
  }), _vm._v(" "), _c('reminder')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('p', [_vm._v("© 2017 社團法人臺灣多寶格藝術發展協會 版權所有")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0538938a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 236
// module chunks = 0